export default __webpack_public_path__ + "static/media/part-4.87c61c81.png";